export class MapsLocale extends Intl.Locale {
    constructor(localeCode: string, use12HourFormat: boolean) {
        // override hour format if specified or use default from specified locale
        const localeOptions: Intl.LocaleOptions = use12HourFormat
            ? {
                  hourCycle: "h12",
              }
            : {};

        // maximize() locale after creation so that all properties are auto-"filled" if not set
        super(new Intl.Locale(localeCode, localeOptions).maximize());
    }

    // Intl.Locale.baseName string also contains "-Latn-" after maximize() (i.e. de-Latn-DE) which we don't
    // want to have, so introduce another property just with the "<language>-<region>" format
    get languageAndRegion() {
        return `${this.language}-${this.region}`;
    }

    // region is always defined in MapsLocale because if maximize() call in constructor, so override
    // region getter signature and remove undefined
    override get region(): string {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return super.region!;
    }
}
